const PHONE_REGEX = /^[\+]?[1-9][\d]{0,15}$|^[\(]?[\d]{3}[\)]?[-\s\.]?[\d]{3}[-\s\.]?[\d]{4}$/;
const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

export const validatePhone = (phone: string): boolean => {
  if (!phone || phone.trim().length === 0) return false;

  const digitsOnly = phone.replace(/\D/g, '');
  if (digitsOnly.length < 10) return false;

  return PHONE_REGEX.test(phone);
};

export const validateZip = (zip: string): boolean => {
  if (!zip || zip.trim().length === 0) return false;
  return ZIP_REGEX.test(zip.trim());
};

export const validateName = (name: string): string | null => {
  if (!name || name.trim().length === 0) return 'Name is required';
  if (name.trim().length < 2) return 'Name must be at least 2 characters';
  return null;
};
